/* Ultrafade Grow page — progressive enhancement adapted from the approved Astro prototype. */
(()=>{'use strict';
  const init=(root=document)=>{
    const scope=root.matches?.('.uf-grow')?root:(root.closest?.('.uf-grow')||document.querySelector('.uf-grow'));
    if(!scope)return;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    const diagrams=[...scope.querySelectorAll('.uf-diagnostic')];
    const applyMotion=()=>diagrams.forEach(d=>d.classList.toggle('uf-running',!reduced.matches));
    applyMotion();
    if(!window.__ufGrowReducedBound){ reduced.addEventListener?.('change',applyMotion); window.__ufGrowReducedBound=true; }
    diagrams.forEach(d=>{
      if(d.dataset.ufGrowInit==='1')return;
      d.dataset.ufGrowInit='1';
      const b=d.querySelector('.uf-motion-toggle');
      if(b){
        b.addEventListener('click',()=>{
          const paused=d.classList.toggle('uf-paused');
          b.setAttribute('aria-pressed',String(paused));
          b.textContent=paused?'Play demonstration':'Pause demonstration';
          b.setAttribute('aria-label',`${paused?'Play':'Pause'} ${d.classList.contains('uf-constraint-visual')?'constraint finder':'hero diagnostic'} animation`);
        });
      }
    });
    scope.querySelectorAll('.uf-walkthrough').forEach(details=>{
      if(details.dataset.ufGrowInit==='1')return;
      details.dataset.ufGrowInit='1';
      details.addEventListener('toggle',()=>{
        if(!details.open){
          const d=details.querySelector('.uf-diagnostic'); if(!d)return;
          d.classList.add('uf-paused');
          const b=d.querySelector('.uf-motion-toggle');
          if(b){ b.textContent='Play demonstration'; b.setAttribute('aria-pressed','true'); b.setAttribute('aria-label','Play constraint finder demonstration'); }
        }
      });
    });
    if('IntersectionObserver'in window && !scope.dataset.ufGrowObserver){
      scope.dataset.ufGrowObserver='1';
      const observer=new IntersectionObserver(entries=>entries.forEach(e=>e.target.classList.toggle('uf-offscreen',!e.isIntersecting)),{threshold:0.05});
      diagrams.forEach(d=>observer.observe(d));
    }
  };
  document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('visibilitychange',()=>document.querySelectorAll('.uf-grow .uf-diagnostic').forEach(d=>d.classList.toggle('uf-page-hidden',document.hidden)));
})();
